// extracted by mini-css-extract-plugin
export default {"container":"ia60V","arrow":"+oPzt","page":"_1YXSq","position":"lgwVN","withPosition":"oZTnS","active":"HpYnP","disabled":"RCelh"};